import { Provider } from "@angular/core";
import { map, Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { DeleteAbsenceResponse } from "../../models/personnel.model";
import { PersonnelRepository } from "../../repositories/personnel.repository";

interface deleteAbsenceParams {
  absenceId: number;
}
export class DeleteAbsenceUseCase implements UseCase<deleteAbsenceParams, any> {
  constructor(private repo: PersonnelRepository) {}

  execute(param: deleteAbsenceParams): Observable<DeleteAbsenceResponse> {
    return this.repo.deleteAbsence(param.absenceId).pipe(
      map((response) => {
        return response;
      }),
    );
  }
}

const deleteAbsenceFactory = (repo: PersonnelRepository) =>
  new DeleteAbsenceUseCase(repo);
export const deleteAbsenceUseCaseProvider: Provider = {
  provide: DeleteAbsenceUseCase,
  useFactory: deleteAbsenceFactory,
  deps: [PersonnelRepository],
};
